import { Flex } from 'components/shared/flex'
import { A4 } from 'components/shared/print'
import * as H from 'history'
import { ReactNode } from 'react'
import { Badge, Button } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { setPageSize } from 'utils/util'

type Props = {
    history: H.History
}

const PcrRunProtocolSheet = (props: Props) => {
    const textRow = (text: ReactNode, nested?: boolean) => {
        return (
            <tr>
                <td style={{ width: 20, verticalAlign: 'top', padding: '5px 3px' }}>{nested ? '' : '☐'}</td>
                <td style={{ padding: '5px 3px' }}>
                    {nested ? (
                        <Flex>
                            <div>☐</div>
                            <div>{text}</div>
                        </Flex>
                    ) : (
                        text
                    )}
                </td>
            </tr>
        )
    }

    setPageSize('portrait')

    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            <A4 landscape={false} padding={5}>
                <div style={{ color: 'red', fontSize: 14 }}>
                    ※すべての操作は、voltexをする際は、渦巻きや液が飛び散るなど溶液がきちんと混ざっていることを確認すること
                </div>
                <div style={{ color: 'red', fontSize: 14 }}>※チューブのフタを開ける際は、チューブの壁面に液が残っていないことを確認すること</div>
                <br></br>
                <div style={{ fontSize: 12 }}>
                    <div>
                        <div style={{ fontWeight: 'bold' }}>下記の試薬を冷凍庫、冷蔵庫から取り出し氷上のアイスラックに置く</div>
                        <div style={{ padding: 10 }}>
                            <table>
                                <tbody>
                                    {textRow(
                                        <>
                                            【<Badge bg="success">MasterMix</Badge>】TaqMan Fast Advanced Maser
                                            Mix(2×)冷蔵庫から取り出した後、voltexを5秒行い、スピンダウンを3秒行う。
                                        </>
                                    )}
                                    {textRow(
                                        <>
                                            【<Badge bg="danger">Probe</Badge>】TaqMan Advanced miRNA Assay
                                            (20×)冷凍庫から取り出した後、融解を確認した後にvoltex5秒行い、スピンダウンを3秒行う。
                                        </>
                                    )}
                                    {textRow(
                                        <>
                                            【<Badge bg="primary">cDNA</Badge>】冷凍庫から取り出した後、融解を確認した後にvoltex5秒行い、スピンダウン3秒行う。
                                        </>
                                    )}
                                    {textRow(
                                        <>
                                            【<Badge bg="info">NFW</Badge>】Nuclease-free water 冷蔵庫から取り出した後、スピンダウン3秒行う。
                                        </>
                                    )}
                                    {textRow(
                                        <>
                                            作業シートに従い、<Badge bg="danger">Probe</Badge>と<Badge bg="primary">cDNA</Badge>
                                            の名前と順番を確認する。
                                        </>
                                    )}
                                    {textRow('チューブを置く振動によっては、液が跳ねるので確認をしてから開封する。', true)}
                                    {textRow('チューブのへりに液がついていたら再度スピンダウンを3秒行う。', true)}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <div style={{ marginTop: 10, fontWeight: 'bold' }}>Probeの調整を行う</div>

                        <div style={{ padding: 10 }}>
                            <table>
                                <tbody>
                                    {textRow('検体数分の1.5mLチューブを準備する。')}
                                    {textRow(
                                        <>
                                            qPCR作業シートに従い必要量の<Badge bg="success">MasterMix</Badge>を各1.5mLチューブに加える。
                                        </>
                                    )}
                                    {textRow('チップ内に溶液が残っていないか確認する。', true)}
                                    {textRow(
                                        <>
                                            チップは各<Badge bg="danger">Probe</Badge>ごとに変える。
                                        </>,
                                        true
                                    )}
                                    {textRow(
                                        <>
                                            qPCR作業シートに従い必要量の<Badge bg="danger">Probe</Badge>を各<Badge bg="success">MasterMix</Badge>
                                            が入った1.5mLチューブに加える。
                                        </>
                                    )}
                                    {textRow('ピペッティングを最低3回行う。', true)}
                                    {textRow('チップ内に溶液が残っていないか確認する。', true)}
                                    {textRow(
                                        <>
                                            チップは各<Badge bg="danger">Probe</Badge>ごとに変える。
                                        </>,
                                        true
                                    )}
                                    {textRow('voltexを5秒行い、スピンダウンを3秒行う。')}
                                    {textRow(
                                        <>
                                            qPCR作業シートに従い、96プレートに<Badge bg="danger">ProbeMix</Badge>の分注を行う。
                                        </>
                                    )}
                                    {textRow('第一段階のプッシュ方法で分注する。', true)}
                                    {textRow(
                                        <>
                                            分注後1.5ｍLのチューブ内の<Badge bg="danger">ProbeMix</Badge>が異常に足りなかったり残っていないか確認する。
                                        </>,
                                        true
                                    )}
                                    {textRow('384プレート1well分以上足りない場合はメモに残す。', true)}
                                    {textRow('1列分注が終わるごとに8連キャップをする。')}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </A4>

            <A4 landscape={false} padding={5}>
                <div style={{ fontSize: 12 }}>
                    <div>
                        <div style={{ marginTop: 10, fontWeight: 'bold' }}>cDNAの調製を行う</div>

                        <div style={{ padding: 10 }}>
                            <table>
                                <tbody>
                                    {textRow(<>検体数分の1.5mLチューブを準備する</>)}
                                    {textRow(
                                        <>
                                            qPCR作業シートに従い必要量の<Badge bg="info">NFW</Badge>を各1.5mLチューブに加える
                                        </>
                                    )}
                                    {textRow('先端に空気が入っていないか確認してから、各1.5mLチューブに加える', true)}
                                    {textRow('チップ内に溶液が残っていないか確認する', true)}
                                    {textRow(
                                        <>
                                            チップは各<Badge bg="primary">cDNA</Badge>ごとに変える
                                        </>,
                                        true
                                    )}
                                    {textRow(
                                        <>
                                            qPCR作業シートに従い必要量の<Badge bg="primary">cDNA</Badge>を各<Badge bg="info">NFW</Badge>
                                            が入った1.5mLチューブに加える
                                        </>
                                    )}
                                    {textRow('ピペッティングを最低3回行う', true)}
                                    {textRow('チップ内に溶液が残っていないか確認する', true)}
                                    {textRow(
                                        <>
                                            チップは各<Badge bg="primary">cDNA</Badge>ごとに変える
                                        </>,
                                        true
                                    )}
                                    {textRow('voltexを5秒行い、スピンダウンを3秒行う')}
                                    {textRow('qPCR作業シートに従い、96プレートにcDNAの分注を行う')}
                                    {textRow(<>第一段階のプッシュ方法で分注する</>, true)}
                                    {textRow(
                                        <>
                                            分注後1.5ｍLのチューブ内の<Badge bg="primary">cDNA</Badge>が異常に足りなかったり残っていないか確認する
                                        </>
                                    )}
                                    {textRow('384プレート1well分以上足りない場合はメモに残す', true)}
                                    {textRow('1列分注が終わるごとに8連キャップをする')}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: 10, fontWeight: 'bold' }}>自動分注機</div>

                        <div style={{ padding: 10 }}>
                            <table>
                                <tbody>
                                    {textRow(
                                        <>
                                            <Badge bg="danger">ProbeMix</Badge>と<Badge bg="primary">cDNA</Badge>
                                            の分注作業が終了したら、voltexを5秒行い、スピンダウンを3秒行う。
                                        </>
                                    )}
                                    {textRow('気泡が残っている場合はタッピングで気泡を消してから再度スピンダウンを行う', true)}
                                    {textRow('qPCR作業シートの表記に従い自動分注機のプロコルに選択し、チップとプレートをセットする。')}
                                    {textRow('チップとプレートの位置がずれていないか確認し、ドアを閉める。')}
                                    {textRow('キャリブレーションで位置相違がないか確認する')}
                                    {textRow('自動分注機をスタートさせる。')}
                                    {textRow('自動分注終了後、384プレートにシールを行う。')}
                                    {textRow('シールが浮いていないか確認する。', true)}
                                    {textRow('voltex5秒行い、スピンダウンを3秒行う。')}
                                    {textRow('384プレートを目視確認し、分注量過不足がないか確認する')}
                                    {textRow('※異常があれば、wellエラー登録を行う', true)}
                                    {textRow('気泡が残っている場合はタッピングで気泡を消してから再度スピンダウンを行う', true)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: 10, fontWeight: 'bold' }}>qPCR装置にかける</div>

                        <div style={{ padding: 10 }}>
                            <table>
                                <tbody>
                                    {textRow('パソコン、QuantStudioの順に電源を入れる。')}
                                    {textRow('QuantStudio™ Design & Analysis Softwareのソフトを立ち上げる。')}
                                    {textRow('New Experimentのタブを開き、templateの「craif_qPCRtemplate384well_211201.edt」を開く。')}
                                    {textRow('FileのImport Plate Setupをクリックし、miSignalシステムからダウンロードしたファイル「XXXX.txt」を開く。')}
                                    {textRow('384 well plateをQS5にセットする。')}
                                    {textRow('qPCRをスタートする。')}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </A4>
        </>
    )
}

export default withRouter(PcrRunProtocolSheet)
